// src/pages/ApplicationChampionshipSeason/shared/steps/Step2Stages/SingleStageCard.tsx
import { FunctionComponent } from 'react';
import { Badge, Box, Flex, Text } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { SeasonFormData } from '../../schemas';
import { QualifierZonesInputs } from './QualifierZonesInputs';

const PREFIX = 'pages.application_season.components.season_step2.league';
const QUALIFIERS_PREFIX = 'pages.application_season.components.season_step2.qualifiers';

export const SingleStageCard: FunctionComponent = () => {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useFormContext<SeasonFormData>();

  const hasQualifiersError =
    !!errors.league_stage_config?.direct_qualifiers_count ||
    !!errors.league_stage_config?.playoff_qualifiers_count ||
    !!errors.league_stage_config?.secondary_qualifiers_count ||
    !!errors.league_stage_config?.relegated_count;

  return (
    <Box borderWidth="1px" borderColor="gray.200" borderRadius="md" p={4}>
      <Text
        fontSize="12px"
        fontWeight="semibold"
        color="gray.500"
        letterSpacing="wide"
        mb={3}
      >
        {t(`${PREFIX}.stage_box_title`)}
      </Text>
      <Flex direction="column" gap={4}>
        <Badge
          colorScheme="green"
          borderRadius="full"
          px={3}
          py={1}
          display="inline-flex"
          alignItems="center"
          gap={1}
          textTransform="none"
          fontWeight="medium"
          alignSelf="flex-start"
        >
          <ChakraFeatherIcon name="list" boxSize="14px" />
          {t(`${PREFIX}.single_stage_label`)}
        </Badge>
        <Box>
          <Text fontSize="13px" fontWeight="semibold" color="gray.700" mb={1}>
            {t(`${QUALIFIERS_PREFIX}.section_title`)}
          </Text>
          <Text fontSize="12px" color="gray.500" mb={3}>
            {t(`${QUALIFIERS_PREFIX}.section_help`)}
          </Text>
          <QualifierZonesInputs
            directName="league_stage_config.direct_qualifiers_count"
            playoffName="league_stage_config.playoff_qualifiers_count"
            secondaryName="league_stage_config.secondary_qualifiers_count"
            relegatedName="league_stage_config.relegated_count"
            directLabelName="league_stage_config.direct_qualifiers_label"
            playoffLabelName="league_stage_config.playoff_qualifiers_label"
            secondaryLabelName="league_stage_config.secondary_qualifiers_label"
            relegatedLabelName="league_stage_config.relegated_qualifiers_label"
            errorMessage={
              hasQualifiersError
                ? t('pages.application_season.components.season_step2.schema.qualifiers_overflow')
                : undefined
            }
          />
        </Box>
      </Flex>
    </Box>
  );
};
